class WspPriceUpdater {
  constructor(blockId, productData) {
    this.blockId = blockId;
    // Ahora inicializamos productInfo con el ID y Handle pasados desde Liquid
    this.productInfo = {
        id: productData.productId,
        handle: productData.productHandle
    };
    this.moneyFormat = productData.moneyFormat;
    this.settings = productData.settings;

    // ... resto del constructor ...

    // --- NUEVO: Lógica para encontrar el objeto 'product' ---
    // Ahora usamos this.productInfo para la búsqueda
    this.product = this.findProductObject();
    if (!this.product) {
        console.error('WSP Price Updater: Could not find product object on the page. Dynamic pricing will not work.');
        return;
    }
    // ... resto del constructor ...
    
    // Asignar currentVariant después de que this.product esté disponible
    this.currentVariant = this.product.selected_or_first_available_variant || this.product.variants[0];

    this.init();
  }

  findProductObject() {
    // Intento 1: Buscar script JSON por ID (común en temas nuevos)
    // Usamos this.productInfo.id aquí
    const productJsonScriptById = document.getElementById(`ProductJson-${this.productInfo.id}`);
    if (productJsonScriptById) {
      try {
        return JSON.parse(productJsonScriptById.textContent);
      } catch (e) {
        console.error("Error parsing ProductJsonScriptById:", e);
      }
    }

    // Intento 2: Buscar scripts JSON genéricos con type="application/json"
    // ... (resto del código igual) ...
    for (const script of genericProductJsonScripts) {
        try {
            const data = JSON.parse(script.textContent);
            if (data && data.variants && Array.isArray(data.variants) && data.variants.length > 0) {
                if (data.handle === this.productInfo.handle) { // Coincidir con el handle
                    return data;
                }
            }
        } catch (e) {} // Ignorar errores
    }

    // Intento 3: Buscar en window.Shopify.Product o window.product
    // ... (resto del código igual) ...
    if (window.Shopify && window.Shopify.Product) {
        if (window.Shopify.Product.handle === this.productInfo.handle) {
            return window.Shopify.Product;
        }
    }
    if (window.product && window.product.handle === this.productInfo.handle) {
        return window.product;
    }

    return null;
  }

  // ... el resto de la clase permanece igual ...
}